import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../../services/navigation.service';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-stacked-combo-bar-card',
    templateUrl: './stacked-combo-bar-chart.component.html',
    styleUrls: ['./stacked-combo-bar-chart.component.scss'],
    standalone: false
})
export class StackedComboChartComponent implements OnInit, OnDestroy {
  static key = 100610;
  
  @Input('item') item: any
  @Input('pageKey') pageKey: any
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>()
  @ViewChild('StackedComboChart', { static: true }) StackedComboChart!: ElementRef
  config: any
  data: any
  heading: any
  isDataLoaded = false
  reqSubcription: Subscription[] = []
  error_name:any;
  prefrenceConfig:any;
  dashboardKey:any

  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient, 
    private apiService: ApiService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private dataService: DataService
  ) {
    this.reqSubcription.push(this.filterService.filterQuery.subscribe((query: any) => {
      this.loadApiData()
    })
    )
        this.route.queryParams.subscribe((params: any) => {
      let decryptedParams = this.navigationService.decryptData(params);
 
      this.dashboardKey = decryptedParams["ds_key"];
    
    });
  }
  ngOnInit(): void {
    this.item

    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height)
    });
    observer.observe(this.StackedComboChart.nativeElement);
    this.loadlineConfig()
  }

  loadlineConfig() {
    this.heading = this.item.config['report_heading']
  }

  loadApiData(reportType?:string) {
    
    this.getPreferences()
    let api = this.item.config["list_of_api"] || "100171"; 
    if((this.filterService.isEmptyObject(this.filterService.baseQuery) == false)) {
      // API Payloads
      let obj:any = {"api_key": api?.api_key || "100171", "time_cycle": this.item.config?.default_timeCycle, "report_typ": this.filterService.report_type}
      let query = Object.assign({}, this.filterService.baseQuery, obj)
      query['module_key'] = this.apiService.getModuleKey();
      let endPoint = this.item.config?.["list_of_api_endpoint"];
      
      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query).subscribe((res:any)=> {
          
          this.isDataLoaded = true
          this.data = res == null ? [] : res
          this.error_name = '';
        },(err:any)=>{
          console.log(err)
          this.data = []
          this.error_name = friendlyApiErrorMessage(err);
          this.isDataLoaded = true;
        })
      )

      // this.reqSubcription.push(this.filterService.selfTimeCycleExecuteQuery(obj).subscribe((res:any)=>{
      //   this.isDataLoaded = true
      //   this.data = res == null ? [] : res
      // }, (error: any) => {
      //   this.data = []
      // }))
    }
  }
   getPreferences() {
    if(this.item?.widget_uniq_key) {
      let obj = {
        dashboard_key: this.dashboardKey,
        page_name:this.item.config["report_heading"],
        page_key: this.pageKey,
        widget_uinique_key: this.item?.widget_uniq_key,
        employee_key: this.filterService.baseQuery?.employee_key || 0
      }
      this.dataService.getPreference(obj).subscribe((res:any) => {
        if(res && res.length) {
          let value = res?.[0]?.preference_value ? JSON.parse(res?.[0]?.preference_value) : '';
          this.prefrenceConfig = value;
        }
      })
    }
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }

}